"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var privateShop = {
  id: "privateShop",
  title: {
    en: "Private shops",
    de: "Private Läden"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Private Shops"), /*#__PURE__*/_react.default.createElement("p", null, "To assist in more effective trading, Ferentus supports private shops for players."), /*#__PURE__*/_react.default.createElement("p", null, "How to Set Up a Private Shop"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "Type '/shop' to see the private shop menu. This is possible only within a city or town."), /*#__PURE__*/_react.default.createElement("li", null, "Select the item you want to sell and move the item into the shop window. The price bar will activate."), /*#__PURE__*/_react.default.createElement("li", null, "Input Your Sales Price"), /*#__PURE__*/_react.default.createElement("li", null, "After moving all the items you want to sell, enter the title of your shop and L_Click 'OK'. Your shop setup is now complete and your character will sit down."))), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        color: "#BC6E13"
      }
    }, "(TIP) If you press 'close' the shop will close."), /*#__PURE__*/_react.default.createElement("p", null, "How to Shop From Private Shops"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "Find a player's private shop."), /*#__PURE__*/_react.default.createElement("li", null, "Double clicking the player will show you the shop window."), /*#__PURE__*/_react.default.createElement("li", null, "From this point, shopping from a PC is the same as shopping from an NPC."))))
  }
};
var _default = privateShop;
exports.default = _default;